'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var callBound = require('call-bind/callBound');

var $byteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);
module.exports = $byteLength ? function isSharedArrayBuffer(obj) {
  if (!obj || _typeof(obj) !== 'object') {
    return false;
  }

  try {
    $byteLength(obj);
    return true;
  } catch (e) {
    return false;
  }
} : function isSharedArrayBuffer(obj) {
  // eslint-disable-line no-unused-vars
  return false;
};